/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BidirectionalActionEnabledItem } from './BidirectionalActionEnabledItem';
import {
    BidirectionalActionEnabledItemFromJSON,
    BidirectionalActionEnabledItemFromJSONTyped,
    BidirectionalActionEnabledItemToJSON,
} from './BidirectionalActionEnabledItem';

/**
 * 
 * @export
 * @interface FacilityIntegration
 */
export interface FacilityIntegration {
    /**
     * 
     * @type {string}
     * @memberof FacilityIntegration
     */
    name: FacilityIntegrationNameEnum;
    /**
     * 
     * @type {boolean}
     * @memberof FacilityIntegration
     */
    is_referral_platform: boolean;
    /**
     * 
     * @type {string}
     * @memberof FacilityIntegration
     */
    status: FacilityIntegrationStatusEnum;
    /**
     * 
     * @type {Array<BidirectionalActionEnabledItem>}
     * @memberof FacilityIntegration
     */
    bidirectional_actions_enabled: Array<BidirectionalActionEnabledItem>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof FacilityIntegration
     */
    attributes?: { [key: string]: any; };
}


/**
 * @export
 */
export const FacilityIntegrationNameEnum = {
    Aida: 'aida',
    Aidin: 'aidin',
    Ensocare: 'ensocare',
    EnsocareVa: 'ensocare_va',
    Repisodic: 'repisodic',
    EpicCareLink: 'epic_care_link',
    EpicCareLinkAlbanyMed: 'epic_care_link_albany_med',
    EpicCareLinkAllinaHealth: 'epic_care_link_allina_health',
    EpicCareLinkAsante: 'epic_care_link_asante',
    EpicCareLinkAscension: 'epic_care_link_ascension',
    EpicCareLinkAspirusHealth: 'epic_care_link_aspirus_health',
    EpicCareLinkAtriumHealth: 'epic_care_link_atrium_health',
    EpicCareLinkBsaHospital: 'epic_care_link_bsa_hospital',
    EpicCareLinkBaptistHealth: 'epic_care_link_baptist_health',
    EpicCareLinkBenefisHealthSystem: 'epic_care_link_benefis_health_system',
    EpicCareLinkBaylorScottWhiteHealth: 'epic_care_link_baylor_scott_white_health',
    EpicCareLinkBryanHealth: 'epic_care_link_bryan_health',
    EpicCareLinkBonSecoursMercyHealth: 'epic_care_link_bon_secours_mercy_health',
    EpicCareLinkBostonMedicalCenter: 'epic_care_link_boston_medical_center',
    EpicCareLinkBronsonHealthcare: 'epic_care_link_bronson_healthcare',
    EpicCareLinkCapeCodHealthcare: 'epic_care_link_cape_cod_healthcare',
    EpicCareLinkCaromont: 'epic_care_link_caromont',
    EpicCareLinkCarolinaEast: 'epic_care_link_carolina_east',
    EpicCareLinkErlanger: 'epic_care_link_erlanger',
    EpicCareLinkCentraCare: 'epic_care_link_centra_care',
    EpicCareLinkChristusHealth: 'epic_care_link_christus_health',
    EpicCareLinkConeHealth: 'epic_care_link_cone_health',
    EpicCareLinkCovenantHealthcare: 'epic_care_link_covenant_healthcare',
    EpicCareLinkDeaconess: 'epic_care_link_deaconess',
    EpicCareLinkDenverHealth: 'epic_care_link_denver_health',
    EpicCareLinkDukeHealth: 'epic_care_link_duke_health',
    EpicCareLinkEcuHealth: 'epic_care_link_ecu_health',
    EpicCareLinkElCaminoHealth: 'epic_care_link_el_camino_health',
    EpicCareLinkEnloeHealth: 'epic_care_link_enloe_health',
    EpicCareLinkFirstHealth: 'epic_care_link_first_health',
    EpicCareLinkGenesisHealthcareSystem: 'epic_care_link_genesis_healthcare_system',
    EpicCareLinkParkview: 'epic_care_link_parkview',
    EpicCareLinkFmolhsCareConnect: 'epic_care_link_fmolhs_care_connect',
    EpicCareLinkSelectMedical: 'epic_care_link_select_medical',
    EpicCareLinkHartfordHealthcare: 'epic_care_link_hartford_healthcare',
    EpicCareLinkHackensackMeridianHealth: 'epic_care_link_hackensack_meridian_health',
    EpicCareLinkHealthPartners: 'epic_care_link_health_partners',
    EpicCareLinkHealtheConnection: 'epic_care_link_healthe_connection',
    EpicCareLinkHennepin: 'epic_care_link_hennepin',
    EpicCareLinkHillcrestHealthcare: 'epic_care_link_hillcrest_healthcare',
    EpicCareLinkHospitalSistersHealthSystem: 'epic_care_link_hospital_sisters_health_system',
    EpicCareLinkHurleyMedicalCenter: 'epic_care_link_hurley_medical_center',
    EpicCareLinkIowaHealthCare: 'epic_care_link_iowa_health_care',
    EpicCareLinkIntegrisHealth: 'epic_care_link_integris_health',
    EpicCareLinkJupiterMedicalCenter: 'epic_care_link_jupiter_medical_center',
    EpicCareLinkKaiserPermanente: 'epic_care_link_kaiser_permanente',
    EpicCareLinkKingsDaughters: 'epic_care_link_kings_daughters',
    EpicCareLinkLegacyHealthyPlanet: 'epic_care_link_legacy_healthy_planet',
    EpicCareLinkMHealthFairview: 'epic_care_link_m_health_fairview',
    EpicCareLinkMainLineHealth: 'epic_care_link_main_line_health',
    EpicCareLinkMayoClinic: 'epic_care_link_mayo_clinic',
    EpicCareLinkMercy: 'epic_care_link_mercy',
    EpicCareLinkMethodistHospitals: 'epic_care_link_methodist_hospitals',
    EpicCareLinkMethodistHealthSystem: 'epic_care_link_methodist_health_system',
    EpicCareLinkMiddlesexHealth: 'epic_care_link_middlesex_health',
    EpicCareLinkMyMichiganHealth: 'epic_care_link_my_michigan_health',
    EpicCareLinkNortonHealthcare: 'epic_care_link_norton_healthcare',
    EpicCareLinkNorthMemorialHealth: 'epic_care_link_north_memorial_health',
    EpicCareLinkOhioHealth: 'epic_care_link_ohio_health',
    EpicCareLinkOklahomaHeartHospital: 'epic_care_link_oklahoma_heart_hospital',
    EpicCareLinkOsfHealthcare: 'epic_care_link_osf_healthcare',
    EpicCareLinkOwensboroHealth: 'epic_care_link_owensboro_health',
    EpicCareLinkPiedmont: 'epic_care_link_piedmont',
    EpicCareLinkProvidence: 'epic_care_link_providence',
    EpicCareLinkSaintFrancis: 'epic_care_link_saint_francis',
    EpicCareLinkShannonHealth: 'epic_care_link_shannon_health',
    EpicCareLinkSsmHealth: 'epic_care_link_ssm_health',
    EpicCareLinkStElizabethHealthcare: 'epic_care_link_st_elizabeth_healthcare',
    EpicCareLinkStormontVailHealth: 'epic_care_link_stormont_vail_health',
    EpicCareLinkTexasHealth: 'epic_care_link_texas_health',
    EpicCareLinkTheQueensHealthSystem: 'epic_care_link_the_queens_health_system',
    EpicCareLinkThedacare: 'epic_care_link_thedacare',
    EpicCareLinkTrihealth: 'epic_care_link_trihealth',
    EpicCareLinkTrinityHealth: 'epic_care_link_trinity_health',
    EpicCareLinkUcHealth: 'epic_care_link_uc_health',
    EpicCareLinkUconnHealth: 'epic_care_link_uconn_health',
    EpicCareLinkUnityPointHealth: 'epic_care_link_unity_point_health',
    EpicCareLinkUniversityOfCincinnati: 'epic_care_link_university_of_cincinnati',
    EpicCareLinkUniversityOfKansas: 'epic_care_link_university_of_kansas',
    EpicCareLinkUniversityOfKansasStFrancis: 'epic_care_link_university_of_kansas_st_francis',
    EpicCareLinkUmms: 'epic_care_link_umms',
    EpicCareLinkUniversityHealth: 'epic_care_link_university_health',
    EpicCareLinkUniversityOfUtah: 'epic_care_link_university_of_utah',
    EpicCareLinkUpmcPinnacle: 'epic_care_link_upmc_pinnacle',
    EpicCareLinkSouthShoreHealth: 'epic_care_link_south_shore_health',
    EpicCareLinkStLukes: 'epic_care_link_st_lukes',
    EpicCareLinkPremierHealth: 'epic_care_link_premier_health',
    EpicCareLinkUncHealth: 'epic_care_link_unc_health',
    EpicCareLinkUtHealthEastTexas: 'epic_care_link_ut_health_east_texas',
    EpicCareLinkUtSouthwestern: 'epic_care_link_ut_southwestern',
    EpicCareLinkVitruvianHealth: 'epic_care_link_vitruvian_health',
    EpicCareLinkWellstar: 'epic_care_link_wellstar',
    EpicCareLinkKetteringHealth: 'epic_care_link_kettering_health',
    EpicCareLinkOmc: 'epic_care_link_omc',
    EpicCareLinkFranciscanHealth: 'epic_care_link_franciscan_health',
    EpicCareLinkMvhs: 'epic_care_link_mvhs',
    EpicCareLinkGeisinger: 'epic_care_link_geisinger',
    EpicCareLinkJpsHealthNetwork: 'epic_care_link_jps_health_network',
    Fax: 'fax',
    ManualUpload: 'manual_upload',
    ManualCopy: 'manual_copy',
    Pcc: 'pcc',
    MatrixCare: 'matrix_care',
    WellskyIntake: 'wellsky_intake',
    WellskyIntakeCareportQuickcase: 'wellsky_intake_careport_quickcase',
    WellskyCareportReferralIntake: 'wellsky_careport_referral_intake',
    WellskyReferralManagement: 'wellsky_referral_management',
    WellskyReferralManagementWebReferral: 'wellsky_referral_management_web_referral',
    FourNext: 'four_next'
} as const;
export type FacilityIntegrationNameEnum = typeof FacilityIntegrationNameEnum[keyof typeof FacilityIntegrationNameEnum];

/**
 * @export
 */
export const FacilityIntegrationStatusEnum = {
    Complete: 'complete',
    Pending: 'pending',
    Disabled: 'disabled',
    Validating: 'validating'
} as const;
export type FacilityIntegrationStatusEnum = typeof FacilityIntegrationStatusEnum[keyof typeof FacilityIntegrationStatusEnum];


/**
 * Check if a given object implements the FacilityIntegration interface.
 */
export function instanceOfFacilityIntegration(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "is_referral_platform" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "bidirectional_actions_enabled" in value;

    return isInstance;
}

export function FacilityIntegrationFromJSON(json: any): FacilityIntegration {
    return FacilityIntegrationFromJSONTyped(json, false);
}

export function FacilityIntegrationFromJSONTyped(json: any, ignoreDiscriminator: boolean): FacilityIntegration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'is_referral_platform': json['is_referral_platform'],
        'status': json['status'],
        'bidirectional_actions_enabled': ((json['bidirectional_actions_enabled'] as Array<any>).map(BidirectionalActionEnabledItemFromJSON)),
        'attributes': !exists(json, 'attributes') ? undefined : json['attributes'],
    };
}

export function FacilityIntegrationToJSON(value?: FacilityIntegration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'is_referral_platform': value.is_referral_platform,
        'status': value.status,
        'bidirectional_actions_enabled': ((value.bidirectional_actions_enabled as Array<any>).map(BidirectionalActionEnabledItemToJSON)),
        'attributes': value.attributes,
    };
}

